import React from "react";
import {PriceSetting} from "./PriceSetting";
import {Button} from "react-bootstrap";

export const PriceSettings = ({prices, index, onPriceAdded, onChange}) => {
    const onDeleteSelf = (row) => {
        prices.splice(row, 1);
        onChange([...prices]);
    };
    const onChangeSelf = (row, price) => {
        const oldValue = prices[row];
        prices.splice(row, 1, {...oldValue, ...price});
        onChange([...prices]);
    };
    return <ul className="price-settings">
        {
            prices.map((price, i) => <li key={`price-settings-${index}-${i}`}>
                <PriceSetting price={price} row={i} namePrefix={`user_setting[price_settings][${index}][prices]`}
                              onDelete={_ => onDeleteSelf(i)} onChange={price => onChangeSelf(i, price)}/>
            </li>)
        }
        <li>
            <Button variant="primary" onClick={onPriceAdded}>価格を追加</Button>
        </li>
    </ul>;
}